const questions2 = [
  {
    id: 1,
    option: "EI",
    question: "다른 고양이 친구들을 만났을 때, 나의 반응은?",
    answers: [
      {
        type: "E",
        content: "넌 누구냥. 누구냥? 어디에서 왔냥?",
      },
      {
        type: "I",
        content: "별로 관심이 없다. 혹은 나 예민해!",
      },
    ],
  },
  {
    id: 2,
    option: "EI",
    question: "집사가 쉬는 날! 집사와 놀기로 했다!",
    answers: [
      {
        type: "E",

        content: "사냥감이다! 활발하게 뛰어다니는 편이다!",
      },
      {
        type: "I",
        content: "귀찮다 냥! 풀썩 드러누워 뒹굴거리며 손만 휘적거리는 편이다.",
      },
    ],
  },
  {
    id: 3,
    option: "EI",
    question: "모르는 인간이 나의 영역에 들어왔다.",
    answers: [
      {
        type: "E",
        content: "가만히 모습을 구경하더니 다가간다.",
      },
      {
        type: "I",
        content: "저리가라 인간... 경계 태세!",
      },
    ],
  },
  {
    id: 4,
    option: "SN",
    question: "눈 앞에서 집사가 사라진다면?",
    answers: [
      {
        type: "S",
        content: "어? 방금까지 있었는데... 나는 내 할 일 하련다!",
      },
      {
        type: "N",
        content: "또 시작이네, 여기저기 찾으러 가자!",
      },
    ],
  },
  {
    id: 5,
    which: "SN",
    question: "날씨가 아주 좋은 주말이다. 뭘 하면 좋을까!",
    answers: [
      {
        type: "S",
        content: "뒹굴 뒹굴. 낮잠 시간. 뒹굴 뒹굴.",
      },
      {
        type: "N",
        content: "야옹! 심심하니까 베란다로 가서 모두에게 내 존재를 알리자.",
      },
    ],
  },
  {
    id: 6,
    which: "SN",
    question: "새로운 장난감이 생긴다면?",
    answers: [
      {
        type: "S",
        content: "별로다 냥. 거들떠보지 않는다.",
      },
      {
        type: "N",
        content: "장난감에 관심이 있다.",
      },
    ],
  },
  {
    id: 7,
    option: "TF",
    question: "우다다하다가 테이블에 머리를 박았다!",
    answers: [
      {
        type: "T",
        content: "고통은 나를 강하게 만든다. 뚝.",
      },
      {
        type: "F",
        content: "목놓아 울면서 아픔을 어필하고 집사를 부른다.",
      },
    ],
  },
  {
    id: 8,
    option: "TF",
    question: "집사가 샤워하러 들어갔는데 나오지 않는다!",
    answers: [
      {
        type: "T",
        content: "신경 안 쓴다.",
      },
      {
        type: "F",
        content: "집사 너 괜찮은 거냥! 기다린다.",
      },
    ],
  },
  {
    id: 9,
    option: "TF",
    question: "집사가 사고쳐서 혼을 낸다.",
    answers: [
      {
        type: "T",
        content: "혼내든 말든! 내가 뭘 했냐 냥!",
      },
      {
        type: "F",
        content: "삐졌다. 구석으로 가서 웅크린다.",
      },
    ],
  },
  {
    id: 10,
    option: "JP",
    question: "아주 마음에 드는 간식을 잔뜩 얻게 되었다.",
    answers: [
      {
        type: "J",
        content: "이건 내일 먹고, 이건 내 소중한 곳에 보관하고!",
      },
      {
        type: "P",
        content: "일단 먹고 보자!",
      },
    ],
  },
  {
    id: 11,
    option: "JP",
    question: "나의 루틴은?!",
    answers: [
      {
        type: "J",
        content: "규칙적인 생활냥! 정해진 루틴이 있다! 집사가 따라야지!",
      },
      {
        type: "P",
        content: "집사의 루틴이 곧 나의 루틴! 오늘은 뭐 해?",
      },
    ],
  },
  {
    id: 12,
    option: "JP",
    question: "자동 급식기를 집사가 사왔다",
    answers: [
      {
        type: "J",
        content: "아침 점심 저녁! 정확하게 나눠 먹겠어.",
      },
      {
        type: "P",
        content: "뷔페가... 여기 있네?",
      },
    ],
  },
];

export default questions2;
